import { api } from "../utils/AuthManager";
const GetAllTariffs = async () => {
  return api
    .get(`/api/tariff/`)

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default GetAllTariffs;
